var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill=false"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.256 21.121L2.97598 12.865C2.83198 12.721 2.65598 12.649 2.44798 12.649C2.23998 12.649 2.06398 12.721 1.91998 12.865C1.77598 13.009 1.70398 13.185 1.70398 13.393C1.70398 13.601 1.77598 13.777 1.91998 13.921L12 24.001L22.08 13.921C22.224 13.777 22.296 13.601 22.296 13.393C22.296 13.185 22.224 13.009 22.08 12.865C21.936 12.721 21.76 12.649 21.552 12.649C21.344 12.649 21.168 12.721 21.024 12.865L12.744 21.121V0.744976C12.744 0.536976 12.672 0.360977 12.528 0.216977C12.384 0.0729766 12.208 0.000976562 12 0.000976562C11.792 0.000976562 11.616 0.0729766 11.472 0.216977C11.328 0.360977 11.256 0.536976 11.256 0.744976V21.121Z",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.64daff18dfb86700e6c0e7f1a6079ffb.svg";
export { ForwardRef as ReactComponent };